<template>
  <a-card title="Listar Cálculos Média">
    <div class="row" style="margin-bottom: 1%">
      <div class="col-md-6">
        <label for="cpf">Com Restrição</label>

        <div class="input-group input-focus">
          <select class="form-select form-input-component" ref="restricao" v-model="response.restricao" @change="validarRestricao">
            <option :value="false">NÃO</option>
            <option :value="true">SIM</option>
          </select>
        </div>
      </div>
      <div class="col-md-6" v-if="response.restricao">
        <label for="restricao">Restrição</label>
        <div class="input-group input-focus select-height is-invalid">
          <Multiselect :style="submitted && response.tiposRestricao.length == 0 ? 'height: 40px; width: 100%;border-color:#dc3545' : 'height: 40px; width: 100%'" v-model="response.tiposRestricao" display="chip" placeholder="" :options="tipoExercicios" optionLabel="descricao"></Multiselect>
        </div>
      </div>
    </div>
    <a-divider type="horizontal" />
    <div class="row">
      <div class="col-md-4" style="margin-bottom: 0.3%">
        <button @click="pesquisar()" class="btn btn-primary" type="button"><i class="fa fa-search"> </i> Pesquisar</button>
        <button type="button" class="btn btn-primary" @click="criarNova" style="margin: 0 5px"><i class="fa fa-plus"> </i> Criar novo</button>
      </div>
    </div>
  </a-card>
  <a-card>
    <a-table :dataSource="lista" :columns="columns" :pagination="paginationConfig">
      <template #restricao="{ record }">
        <span> {{ record.restricao ? 'SIM' : 'NÃO' }}</span>
      </template>
      <template #tiposRestricao="{ record }">
        <span> {{ record.tiposRestricao ? record.tiposRestricao.map((obj) => obj.descricao).join('; ') : '' }}</span>
      </template>
      <template #action="{ record }">
        <a title="Visualizar" @click="visualizar(record, false)">
          <i class="fas fa-eye icon-trash"></i>
        </a>
        &nbsp;&nbsp;
        <a title="Excluir" @click="excluir(record)"><i class="fas fa-trash icon-trash"></i></a>
        &nbsp;&nbsp;
        <a title="Editar" @click="editar(record)"><i class="fas fa-edit icon-edit"></i></a>
        &nbsp;&nbsp;
        <a title="Histórico" @click="visualizar(record, true)">
          <i class="fas fa-history icon-trash"></i>
        </a>
      </template>
    </a-table>
  </a-card>
  <Dialog
    :header="isHistorico ? 'Histórico' : 'Detalhes Cálculo'"
    v-model:visible="showDialog"
    style="
       {
        backgroundcolor: #dcdeff;
        width: 30%;
      }
    "
    id="showDialog"
  >
    <div class="row">
      <div><label style="margin-left: 1px; font-weight: bold">Possui Restrição: </label> {{ this.recordSelecionado.restricao ? 'SIM' : 'NÃO' }}</div>
      <div v-if="this.recordSelecionado.restricao"><label style="margin-left: 1px; font-weight: bold">Restrições: </label> {{ this.recordSelecionado.tiposRestricao ? this.recordSelecionado.tiposRestricao.map((obj) => obj.descricao).join('; ') : '-' }}</div>
    </div>
    <a-divider type="horizontal" />
    <div class="row">
      <div>
        <a-table :dataSource="isHistorico ? historico : recordSelecionado.calculos" :columns="isHistorico ? columnsSubTableHistorico : columnsSubTable" :key="this.recordSelecionado.id">
          <template #dataAlteracao="{ record }">
            <span> {{ dataFormatada(record.data) }}</span>
          </template>
        </a-table>
      </div>
    </div>
  </Dialog>
</template>

<script>
import { openNotification, typesNotification } from '@/utils/notifications';
import { deleteById, getLista, historico } from '@/components/service/parametroTafCalculoMediaService';
import { formatarData } from '@/utils/servicos-utils';
import { EnumTipoExercicio } from '@/components/models/enumTipoExercicio';
export default {
  name: 'PageListarCalculoMedia',
  data() {
    return {
      response: {
        restricao: false,
        tiposRestricao: [],
      },
      tipoExercicios: EnumTipoExercicio(),
      lista: [],
      historico: [],
      isHistorico: false,
      showDialog: false,
      paginationConfig: {
        pageSize: 10, // Define o número de itens por página
        total: 0, // Total de itens no dataSource
      },
      columns: [
        {
          title: 'Com Restrição',
          dataIndex: 'restricao',
          key: 'restricao',
          slots: { customRender: 'restricao' },
        },

        {
          title: 'Restrições',
          dataIndex: 'tiposRestricao',
          key: 'tiposRestricao',
          slots: { customRender: 'tiposRestricao' },
        },

        {
          title: 'Ações',
          dataIndex: 'action',
          key: 'action',
          slots: { customRender: 'action' },
        },
      ],
      columnsSubTable: [
        {
          title: 'Faixa Etária',
          dataIndex: 'faixaEtaria.nome',
          key: 'faixaEtaria.nome',
        },
        {
          title: 'Formula',
          dataIndex: 'formula',
          key: 'formula',
        },
      ],
      columnsSubTableHistorico: [
        {
          title: 'Data Alteração',
          dataIndex: 'data',
          key: 'dataAlteracao',
          slots: { customRender: 'dataAlteracao' },
        },
        {
          title: 'Usuário Nome',
          dataIndex: 'usuario.nome',
          key: 'usuario.nome',
        },
        {
          title: 'Usuário Cpf',
          dataIndex: 'usuario.cpf',
          key: 'usuario.cpf',
        },
      ],
    };
  },
  methods: {
    excluir(record) {
      deleteById(record.id)
        .then(() => {
          openNotification(typesNotification.success, 'Excluído com sucesso.');
          this.pesquisar();
        })
        .catch(() => {
          openNotification(typesNotification.error, 'Falha ao excluir!');
        });
    },
    editar(record) {
      this.$router.push({ path: '/form-calculo-media', query: { id: record.id } });
    },
    visualizar(record, isHistorico) {
      this.recordSelecionado = record;
      this.showDialog = true;
      this.isHistorico = isHistorico;
      if (isHistorico) {
        historico({ id: record.id })
          .then((r) => {
            this.historico = r.data;
          })
          .catch(() => {
            openNotification(typesNotification.error, 'Erro ao tentar consultar o histórico!');
          });
      }
    },
    criarNova() {
      this.$router.push('form-calculo-media');
    },
    validarRestricao() {
      this.response.tiposRestricao = [];
    },
    async pesquisar() {
      getLista(this.response)
        .then((r) => {
          if (r.data.length > 0) {
            this.lista = r.data;
          } else {
            openNotification(typesNotification.info, 'Nenhum registro encontrado para os dados informados na pesquisa!');
            this.lista = r.data;
          }
        })
        .catch(() => {
          openNotification(typesNotification.error, 'Falha ao recuperar a lista de cadastrados!');
        });
    },
    dataFormatada(obj) {
      if (obj) {
        return formatarData(new Date(obj), 'DD/MM/YYYY HH:mm:ss');
      } else {
        return '';
      }
    },
  },
  created() {
    this.pesquisar();
  },
};
</script>

<style>
.input-group-text {
  height: 38px;
}

.input-group-prepend {
  cursor: pointer;
  margin-left: 8px !important;
}

.input-group-text:hover {
  background-color: #e0e0e0 !important;
}

.h2 {
  font-size: x-large;
}
</style>
